export default __webpack_public_path__ + "static/media/ImperialClosed.564a73d7.jpg";